import { Outlet } from 'react-router-dom';
import { useFlushOnHide } from '../../modules/event-log';
import { ErrorBoundary } from './ErrorBoundary';
import { Footer } from './Footer/Footer';
import { Header } from './Header/Header';

export const Layout = () => {
    // SWRN-1639 (A2): one global listener that beacons a `page hidden` event
    // when the tab is backgrounded/closed.
    useFlushOnHide();

    return (
        <>
            <Header />
            <main>
                <ErrorBoundary>
                    <Outlet />
                </ErrorBoundary>
            </main>
            <Footer />
        </>
    );
};
